import React from 'react';
import { Card } from '@ncoder/ui';
import { TrafficControl } from '../../atoms/deployment';

interface TrafficManagementProps {
  productionTraffic: string;
  canaryEnabled: boolean;
  onProductionTrafficChange: (value: string) => void;
  onCanaryEnabledChange: (enabled: boolean) => void;
}

export const TrafficManagement: React.FC<TrafficManagementProps> = ({
  productionTraffic,
  canaryEnabled,
  onProductionTrafficChange,
  onCanaryEnabledChange,
}) => {
  return (
    <Card className="p-6">
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold mb-4">Traffic Distribution</h3>
          <div className="space-y-4">
            <TrafficControl
              label="Production Traffic"
              description="Percentage of traffic routed to production"
              type="percentage"
              value={productionTraffic}
              onChange={onProductionTrafficChange}
            />
            <TrafficControl
              label="Canary Deployment"
              description="Enable gradual rollout to subset of users"
              type="toggle"
              value={canaryEnabled}
              onChange={onCanaryEnabledChange}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};
